import { User } from 'oidc-client-ts'
import { createContext } from 'react'

export interface AuthProviderState {
  error: Error | null
  isSyncingAuths: boolean
  isInitialised: boolean
  hasLinkSent?: boolean
  signUpUser: User | null
}

export interface SignInOptions {
  /**
   * The requested signin prompt, should be 'create' when
   * directing the user to register
   */
  prompt?: 'create'
  redirectUri?: string
}

export interface AuthContextProps extends AuthProviderState {
  /**
   * Do we have an authenticated user on the current
   * session
   */
  isAuthenticated: boolean
  /**
   * Has the user confirmed their email address
   */
  isConfirmed: boolean
  accessToken?: string
  accessTokenState: 'active' | 'expired' | 'empty'
  /**
   * The user instance from the auth provider
   */
  authUser: User | null

  signIn(options?: SignInOptions): void

  signOut(options?: { returnTo?: string }): Promise<void>
}

export const AuthContext = createContext<AuthContextProps>({
  error: null,
  isSyncingAuths: false,
  isInitialised: false,
  signUpUser: null,
  isAuthenticated: false,
  isConfirmed: false,
  accessTokenState: 'empty',
  authUser: null,
  signIn() {},
  async signOut() {},
})
